<div fxFill fxLayout="column" fxLayoutAlign="start">
    <mat-toolbar color="primary" class="toolbar">
        <app-back-button color="secondary" [route]="['/home', 'perfil']"></app-back-button>
        <div>{{ "PAYMENT_METHODS.TITLE" | translate }}</div>
    </mat-toolbar>

    <div fxLayout.xs="column" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <mat-form-field appearance="outline" fxFlex fxFill>
            <mat-label>{{ "PAYMENT_METHODS.AFFILIATES" | translate }}</mat-label>
            <mat-select
                [multiple]="false"
                [(value)]="selectedAffiliateValue"
                (selectionChange)="selectedAffiliate.next($event.value)"
                [compareWith]="compareAffiliate"
            >
                <input
                    [id]="'input_search'"
                    [placeholder]="'SEARCH' | translate"
                    class="select-search"
                    matInput
                    autocomplete="off"
                    [ngModel]="affiliateFilter$ | async"
                    (ngModelChange)="affiliateFilter$.next($event)"
                />
                <ngx-spinner
                    name="search"
                    [fullScreen]="false"
                    bdColor="rgba(0,0,0,0.2)"
                    type="ball-spin"
                    size="default"
                ></ngx-spinner>
                <mat-option *ngFor="let affiliate of affiliates" [value]="affiliate">
                    {{ affiliate.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex fxFill>
            <mat-label>{{ "PAYMENT_METHODS.PAYMENT_GATEWAYS" | translate }}</mat-label>
            <mat-select [(value)]="selectedGatewayValue" (selectionChange)="selectedGateway.next($event.value)">
                <ng-container *ngIf="selectedAffiliate | async as affiliate">
                    <mat-option *ngIf="affiliate.gatewaysSettings?.iuguData?.active" value="Iugu">Iugu</mat-option>
                    <mat-option *ngIf="affiliate.gatewaysSettings?.asaasData?.active" value="Asaas">Asaas</mat-option>
                    <mat-option *ngIf="affiliate.gatewaysSettings?.vindiData?.active" value="Vindi">Vindi</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-card *ngFor="let card of customerGatewaySettings?.creditCards" fxFlex="100%" fxFlex.gt-sm="20%">
            <div fxLayout="row" fxLayoutAlign="start center">
                <img
                    class="issuer-flag"
                    [src]="'assets/images/payment_companies/' + card.issuer.toLowerCase() + '.png'"
                    alt="Card Issuer"
                />
                <mat-card-header fxFlex>
                    <mat-card-title>{{ card.displayNumber }}</mat-card-title>
                    <mat-card-subtitle>{{ card.holderName }}</mat-card-subtitle>
                    <mat-card-subtitle
                        >{{ "PAYMENT_METHODS.EXPIRES" | translate }}: {{ card.month }}/{{
                            card.year
                        }}</mat-card-subtitle
                    >
                    <mat-icon *ngIf="card.isDefault" color="primary">star</mat-icon>
                </mat-card-header>
            </div>
            <mat-card-actions align="end">
                <button mat-button *ngIf="!card.isDefault" (click)="setAsDefault(card.externalId)">
                    {{ "PAYMENT_METHODS.SET_AS_DEFAULT.LABEL" | translate }}
                </button>
                <button mat-button color="warn" (click)="deleteCard(card.externalId)">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>
    </div>

    <!-- Botão FAB para adicionar novo cartão -->
    <button *ngIf="customerGatewaySettings" mat-fab color="primary" class="add-fab" (click)="addNewCard()">
        <mat-icon>add</mat-icon>
    </button>
</div>
